export default __webpack_public_path__ + "static/media/hexagon-empty.203036de.svg";